// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Select,
//   Upload,
//   Card,
//   message,
//   Layout,
//   Image,
//   Divider,
//   Space,
//   Menu,
//   Radio,
//   Checkbox,
//   Typography
// } from "antd";
// import {
//   UploadOutlined,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
// } from "@ant-design/icons";
// import Sider from "antd/es/layout/Sider";
// import { Header } from "antd/es/layout/layout";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import countries from "world-countries";
// import { MenuOutlined } from "@ant-design/icons";

// const { TextArea } = Input;
// const { Content } = Layout;
// const { Text } = Typography;

// const UserPage = () => {
//   const [form] = Form.useForm();
//   const navigate = useNavigate();

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [allAsanas, setAllAsanas] = useState([]);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   const [imageFile, setImageFile] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [submitting, setSubmitting] = useState(false);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     const fetchAsanas = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const res = await axios.get(`${BASE_URL}/asanadetails`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setAllAsanas(res.data.asanas || []);
//       } catch (err) {
//         console.log(err);
//       }
//     };
//     fetchAsanas();
//   }, []);

//   const stripQuotes = (v) => {
//     if (typeof v !== "string") return v;
//     return v.replace(/^"(.*)"$/, "$1").replace(/^'(.*)'$/, "$1");
//   };

//   const onImageSelect = (file) => {
//     setImageFile(file);
//     setImagePreview(URL.createObjectURL(file));
//   };

//   const onFinish = async (values) => {
//     if (!imageFile) {
//       message.error("Please upload an image file.");
//       return;
//     }

//     setSubmitting(true);

//     try {
//       const token = sessionStorage.getItem("token");
//       const poseTypeArray = stripQuotes(values.poseType || "")
//         .split(",")
//         .map((s) => s.trim())
//         .filter(Boolean);

//       const fd = new FormData();

//       fd.append("name", stripQuotes(values.name));
//       fd.append("sanskrit", stripQuotes(values.sanskrit));
//       fd.append("country", stripQuotes(values.country));
//       fd.append("english", stripQuotes(values.english));
//       fd.append("parentAsana", stripQuotes(values.parentAsana || ""));
//       fd.append("level", stripQuotes(values.level));
//       poseTypeArray.forEach((item) => fd.append("poseType[]", item));
//       fd.append("image", imageFile);
//       fd.append("agreeForImage", stripQuotes(values.agreeForImage));
//       fd.append("mediaLink", stripQuotes(values.mediaLink));

//       const res = await axios.post(`${BASE_URL}/uservariations`, fd, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setSuccessPopup(true);

//       message.success("Variation uploaded successfully!");
//       form.resetFields();
//       setImageFile(null);
//       setImagePreview(null);
//     } catch (err) {
//       setErrorPopup(true);
//       message.error("Upload failed");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isMobile={isMobile} role="user" />
//       <Layout
//         style={{
//           marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
//           transition: "0.3s ease",
//           width: "100%",
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>Upload User Variation</Text>
//           </div>
//         </Header>

//         <Content style={{ padding: 20 }}>
//           <Card style={{ maxWidth: 900, margin: "0 auto" }}>
//             <Form form={form} layout="vertical" onFinish={onFinish}>
//               <Card title="Basic Information" style={{ marginBottom: 20 }}>
//                 <Form.Item
//                   label="Name"
//                   name="name"
//                   rules={[{ required: true, message: "Enter name" }]}
//                 >
//                   <Input placeholder="Padmasana in Aranyasana" />
//                 </Form.Item>
//                 <Form.Item label="Parent Asana" name="parentAsana">
//                   <Select
//                     showSearch
//                     placeholder="Search parent asana..."
//                     allowClear
//                     filterOption={(input, option) =>
//                       option.label.toLowerCase().includes(input.toLowerCase())
//                     }
//                     options={allAsanas.map((a) => ({
//                       value: a._id,
//                       label: a.name,
//                     }))}
//                   />
//                 </Form.Item>

//                 <Form.Item
//                   label="Sanskrit"
//                   name="sanskrit"
//                   rules={[{ required: true, message: "Enter sanskrit" }]}
//                 >
//                   <Input placeholder="Sanskrit name" />
//                 </Form.Item>

//                 <Form.Item
//                   label="English"
//                   name="english"
//                   rules={[{ required: true, message: "Enter English" }]}
//                 >
//                   <Input placeholder="English name" />
//                 </Form.Item>

//                 <Form.Item
//                   label="Country"
//                   name="country"
//                   rules={[{ required: true, message: "Please select country" }]}
//                 >
//                   <Select
//                     showSearch
//                     placeholder="Select country"
//                     options={countries.map((c) => ({
//                       label: c.name.common,
//                       value: c.name.common,
//                     }))}
//                   />
//                 </Form.Item>

//                 <Form.Item
//                   label="Pose Type (comma separated)"
//                   name="poseType"
//                   rules={[{ required: true, message: "Enter pose types" }]}
//                 >
//                   <Input placeholder="prone, backbend" />
//                 </Form.Item>

//                 <Form.Item
//                   label="Media link"
//                   name="mediaLink"
//                   rules={[{ required: true, message: "Enter media link" }]}
//                 >
//                   <Input placeholder="prone, backbend" />
//                 </Form.Item>
//               </Card>

//               <Card title="Image Upload" style={{ marginBottom: 20 }}>
//                 <Form.Item label="Upload Image (required)">
//                   <Upload
//                     beforeUpload={(file) => {
//                       onImageSelect(file);
//                       return false;
//                     }}
//                     accept="image/*"
//                     maxCount={1}
//                   >
//                     <Button icon={<UploadOutlined />}>Choose Image</Button>
//                   </Upload>

//                   {imagePreview && (
//                     <div style={{ marginTop: 12 }}>
//                       <Image src={imagePreview} width={240} />
//                     </div>
//                   )}
//                 </Form.Item>
//               </Card>

//               <Form.Item
//                 name="agreeForImage"
//                 valuePropName="checked"
//                 rules={[
//                   {
//                     validator: (_, value) =>
//                       value
//                         ? Promise.resolve()
//                         : Promise.reject("Please accept the agreement"),
//                   },
//                 ]}
//               >
//                 <Checkbox>
//                   I agree to the royalty-free use of my image(s)
//                 </Checkbox>
//               </Form.Item>

//               <Divider />
//               <Space>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={submitting}
//                   style={{ width: 200 }}
//                 >
//                   Submit Variation
//                 </Button>

//                 <Button
//                   onClick={() => {
//                     form.resetFields();
//                     setImageFile(null);
//                     setImagePreview(null);
//                     message.info("Form reset");
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Space>

//               <SuccessPopup
//                 open={successPopup}
//                 onClose={() => setSuccessPopup(false)}
//                 message="Asana uploaded successfully!"
//                 navigate="/my-variation"
//               />

//               <ErrorPopup
//                 open={errorPopup}
//                 onClose={() => setErrorPopup(false)}
//                 message="Upload failed. Try again."
//               />
//             </Form>
//           </Card>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default UserPage;
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Card,
  message,
  Layout,
  Image,
  Divider,
  Space,
  Menu,
  Radio,
  Checkbox,
  Typography,
} from "antd";
import {
  UploadOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";
import { Header } from "antd/es/layout/layout";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import countries from "world-countries";
import { MenuOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Content } = Layout;
const { Text } = Typography;

const UserPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [allAsanas, setAllAsanas] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const countMediaLinks = (name) => {
    if (!name?.trim()) return 1;
    const segments = name.split(/\s+in\s+/i).filter(Boolean);
    return Math.min(segments.length, 3);
  };

  const [mediaLinkCount, setMediaLinkCount] = useState(1);
  const [errorMessage, setErrorMessage] = useState("Upload failed. Try again.");

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const fetchAsanas = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await axios.get(`${BASE_URL}/asanadetails`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAllAsanas(res.data.asanas || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAsanas();
  }, []);

  const stripQuotes = (v) => {
    if (typeof v !== "string") return v;
    return v.replace(/^"(.*)"$/, "$1").replace(/^'(.*)'$/, "$1");
  };

  const onImageSelect = (file) => {
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const onFinish = async (values) => {
    if (!imageFile) {
      message.error("Please upload an image file.");
      return;
    }

    setSubmitting(true);

    try {
      const token = sessionStorage.getItem("token");
      const poseTypeArray = stripQuotes(values.poseType || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      const fd = new FormData();

      fd.append("name", stripQuotes(values.name));
      fd.append("sanskrit", stripQuotes(values.sanskrit));
      fd.append("country", stripQuotes(values.country));
      fd.append("english", stripQuotes(values.english));
      fd.append("parentAsana", stripQuotes(values.parentAsana || ""));
      fd.append("level", stripQuotes(values.level));
      poseTypeArray.forEach((item) => fd.append("poseType[]", item));
      fd.append("image", imageFile);
      fd.append("agreeForImage", stripQuotes(values.agreeForImage));
      fd.append("mediaLink", stripQuotes(values.mediaLink));

      const res = await axios.post(`${BASE_URL}/uservariations`, fd, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSuccessPopup(true);

      message.success("Variation uploaded successfully!");
      form.resetFields();
      setImageFile(null);
      setImagePreview(null);
    } catch (err) {
      const msg = err?.response?.data?.message;
      setErrorMessage(msg || "Upload failed. Try again.");
      setErrorPopup(true);
      message.error(msg || "Upload failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        role="user"
      />
      <Layout
        style={{
          marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
          transition: "0.3s ease",
          width: "100%",
        }}
      >
        <Header className="MainHeader">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>
              Upload User Variation
            </Text>
          </div>
        </Header>

        <Content style={{ padding: 20 }}>
          <Card style={{ maxWidth: 900, margin: "0 auto" }}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Card title="Basic Information" style={{ marginBottom: 20 }}>
                {/* 1. Sanskrit Name */}
                <Form.Item
                  label="Sanskrit"
                  name="sanskrit"
                  rules={[{ required: true, message: "Enter sanskrit" }]}
                >
                  <Input placeholder="Sanskrit name" />
                </Form.Item>

                {/* 2. English Name */}
                <Form.Item
                  label="English"
                  name="english"
                  rules={[{ required: true, message: "Enter English" }]}
                >
                  <Input placeholder="English name" />
                </Form.Item>

                {/* 3. Pose Type */}
                <Form.Item
                  label="Pose Type (comma separated)"
                  name="poseType"
                  rules={[{ required: true, message: "Enter pose types" }]}
                >
                  <Input placeholder="prone, backbend" />
                </Form.Item>

                {/* 4. Name */}
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[{ required: true, message: "Enter name" }]}
                  extra={
                    mediaLinkCount > 1 ? (
                      <div
                        style={{
                          marginTop: 6,
                          padding: "6px 10px",
                          background: "#fff7ed",
                          border: "1px solid #fed7aa",
                          borderRadius: 6,
                          fontSize: 12,
                          color: "#c2410c",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        ⚠️ This name contains{" "}
                        <strong>{mediaLinkCount} combined asanas</strong> — it
                        will count as{" "}
                        <strong>{mediaLinkCount} media links</strong> against
                        your limit.
                      </div>
                    ) : null
                  }
                >
                  <Input
                    placeholder="Username"
                    onChange={(e) =>
                      setMediaLinkCount(countMediaLinks(e.target.value))
                    }
                  />
                </Form.Item>

                <Form.Item label="Parent Asana" name="parentAsana">
                  <Select
                    showSearch
                    placeholder="Search parent asana..."
                    allowClear
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={allAsanas.map((a) => ({
                      value: a._id,
                      label: a.name,
                    }))}
                  />
                </Form.Item>

                {/* 5. Country */}
                <Form.Item
                  label="Country"
                  name="country"
                  rules={[{ required: true, message: "Please select country" }]}
                >
                  <Select
                    showSearch
                    placeholder="Select country"
                    options={countries.map((c) => ({
                      label: c.name.common,
                      value: c.name.common,
                    }))}
                  />
                </Form.Item>

                {/* 6. Media Link */}
                <Form.Item
                  label="Media link"
                  name="mediaLink"
                  rules={[{ required: true, message: "Enter media link" }]}
                >
                  <Input placeholder="https://example.com/media" />
                </Form.Item>
              </Card>

              {/* 7. Image Upload */}
              <Card title="Image Upload" style={{ marginBottom: 20 }}>
                <Form.Item label="Upload Image (required)">
                  <Upload
                    beforeUpload={(file) => {
                      onImageSelect(file);
                      return false;
                    }}
                    accept="image/*"
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>Choose Image</Button>
                  </Upload>

                  {imagePreview && (
                    <div style={{ marginTop: 12 }}>
                      <Image src={imagePreview} width={240} />
                    </div>
                  )}
                </Form.Item>
              </Card>

              <Form.Item
                name="agreeForImage"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject("Please accept the agreement"),
                  },
                ]}
              >
                <Checkbox>
                  We only have the right to show it for the rest of our lives.
                </Checkbox>
              </Form.Item>

              <Divider />
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitting}
                  style={{ width: 200 }}
                >
                  Submit Variation
                </Button>

                <Button
                  onClick={() => {
                    form.resetFields();
                    setImageFile(null);
                    setImagePreview(null);
                    message.info("Form reset");
                  }}
                >
                  Reset
                </Button>
              </Space>

              <SuccessPopup
                open={successPopup}
                onClose={() => setSuccessPopup(false)}
                message="Asana uploaded successfully!"
                navigate="/my-variation"
              />

              <ErrorPopup
                open={errorPopup}
                onClose={() => setErrorPopup(false)}
                message={errorMessage}
              />
            </Form>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserPage;
